import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import './index.css';
//import App from './App';
//import App2 from './App2';
import MinuteSeriesLineChart from './App5.mjs';

import reportWebVitals from './reportWebVitals';
//import AllChart from './AllChart';
//import NivoRankChart from './Nivo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter>
      <Routes>
        <Route path="/rpp" element={<MinuteSeriesLineChart />} />
        <Route path="/" element={<h1>楽天様のためのアプリ</h1>} />
        <Route path="*" element={<h1>404 Not Found.</h1>} />
      </Routes>
    </BrowserRouter>

    {/* <AllChart /> */}
    {/* <NivoRankChart /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
